import script from "./SelectLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectLocation.vue?vue&type=script&setup=true&lang=js"

import "./SelectLocation.vue?vue&type=style&index=0&id=7e1328d0&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1328d0"]])

export default __exports__